import { useEffect, useState } from "react";
import { XIcon } from "@heroicons/react/outline";
import {
  createTechnicalRider,
  updateTechnicalRider,
} from "../../api/techRiderApi";

const TechnicalRiderModal = ({
  isOpen,
  onClose,
  artistId,
  onSuccess,
  initialData = null,
}) => {
  const [form, setForm] = useState({
    name: "",
    link: "",
    pdf: null,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //if (!isOpen) return null;

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setError("");
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("artist", artistId);
      formData.append("name", form.name);

      if (form.link) {
        formData.append("link", form.link);
      }

      if (form.pdf) {
        formData.append("pdf_file", form.pdf);
      }

      if (initialData) {
        await updateTechnicalRider(initialData.id, formData);
      } else {
        await createTechnicalRider(formData);
      }

      onSuccess();

      // reset only on success
      // setForm({
      //   name: "",
      //   link: "",
      //   pdf: null,
      // });
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
          "Something went wrong with technical rider",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    //if (!isOpen) return null;

    if (initialData) {
      setForm({
        name: initialData.name || "",
        link: initialData.link || "",
        pdf: null,
      });
    } else {
      setForm({
        name: "",
        link: "",
        pdf: null,
      });
    }

    setError("");
  }, [isOpen, initialData]);

  if (!isOpen) return;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-lg bg-slate-900 border border-white/10 rounded-xl shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">
            {initialData ? "Edit Technical Rider" : "Add Technical Rider"}
          </h2>

          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          {/* Item Name */}
          <div>
            <label className="block text-sm text-slate-300 mb-1">
              Item Name
            </label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white
                focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            />
          </div>

          {/* Link */}
          <div>
            <label className="block text-sm text-slate-300 mb-1">Link</label>
            <input
              type="url"
              value={form.link}
              onChange={(e) => handleChange("link", e.target.value)}
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white
                focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            />
          </div>

          {/* PDF */}
          <div>
            <label className="block text-sm text-slate-300 mb-1">
              Upload PDF
            </label>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => handleChange("pdf", e.target.files[0])}
              className="w-full text-sm text-slate-400"
            />
          </div>

          {/* Error */}
          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm px-4 py-2 rounded-lg">
              {error}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg text-slate-300 hover:bg-slate-800 transition"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className={`px-4 py-2 text-sm rounded-lg text-white font-medium transition
              ${
                loading
                  ? "bg-pink-400 cursor-not-allowed"
                  : "bg-pink-600 hover:bg-pink-700"
              }
            `}
          >
            {loading ? "Saving..." : initialData ? "Update Item" : "Add Item"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TechnicalRiderModal;
